/**
 * Pan cancer card component
 */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ChangeDetectorRef,
  NgZone,
  ElementRef
} from '@angular/core';
import { EventService } from '@ispm-client/modules/events/services/event.service';
import { IEventDefinition, IEvent, IEventManagerConfig } from '../../Interfaces/index';
import { Map as immuteMap } from 'immutable';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { get, set, filter, omit, sortBy, findIndex, isEmpty, has } from 'lodash';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';
import { FormHandlerService } from '@ispm/dynamic-form/services/form-handler.service';
import { ModalLoaderNgjsService } from '@ispm/layout/services/modal-loader-ngjs.service';
import { ConfirmModalLoaderPayload } from '@ispm/layout/classes/confirm-modal-loader-payload';
import { Subscription } from 'rxjs';
import { FileService } from '@ispm-client/modules/file-module/services/file.service';
import { CORE_ACTIONS } from '@ispm/core/constants/core-actions.constant';
import {Store} from '@ngrx/store';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import {PermissionSchemaConstants} from '@ispm/shared/constants/permission-schema.constants';
import {ContextProviderService} from '@ispm-client/modules/context-provider/services/context-provider.service';
import moment from 'moment';
import {WorkflowUtilService} from '@ispm-client/modules/aggregator/services/workflow-util.service';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import {Subject} from "rxjs/index";
import {distinctUntilChanged, takeUntil} from "rxjs/operators";
import {AgregationService} from "@ispm-client/modules/aggregator/services";
import {NOTIFICATION_MESSAGE} from "@ispm-client/modules/aggregator/services/consts";
import {IOrdersState} from "@ispm-client/modules/orders/interfaces";
import {EventValidationWizardService} from "@ispm-client/modules/events/services/event-validation-wizard.service";
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import { PacsLauncherService } from '@ispm-client/modules/pacs-launcher/services/pacs-launcher.service';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import {OrderService} from "@ispm-client/modules/orders/services/order.service";


@Component({
  selector: 'ispm-pan-cancer-events',
  templateUrl: './events-manager.component.html',
  styleUrls: ['./events-manager.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('EventManager')
export class EventsManagerComponent implements OnInit, IWidgetItem {
  public ModalLoaderTunnelName: string = EventService.ModalLoaderTunnelName;
  @Input() payload;
  selectedEvent: IEvent;
  allEvents: Array<IEvent>;
  eventCatAndEvents: Map<string, Array<IEvent>>;
  eventsDefinitions: immuteMap<string, IEventDefinition>;
  patientId;
  load: boolean = true;
  showEventsPanel: boolean = true;
  listEl;
  contentEl;
  config: IEventManagerConfig;
  eventDataSubscription: Subscription;
  events: any;
  private permitPanCancerEventRead: boolean;
  showEventsGroup: boolean = true;
  maxEventSelection: number;
  private eventDataUpdated: boolean = false;
  showMiniEventList: boolean = false;
  public permitPanCancerEventWrite: boolean;
  showEventList: boolean = true;
  showAddButton: boolean = true;
  filterCategory: string;
  eventSelectedSubscription: Subscription;
  showNewAddButton: boolean = false;
  isGroupByDate: boolean = false;
  isEditable: boolean = true;
  eventSelection: any;
  private readOnlyMode: boolean = false;
  public widgetFormInstance: FormGroup;
  private asyncdestroyer: Subject<any> = new Subject();
  public isExternal: boolean = false ;
  viewWizard: any;
  public store$: Store<IOrdersState>;
  public showLaunchPacsInEventContent: boolean;
  public showLaunchPacsInReportPreview: boolean;
  public pacsIntegrationAvailable: boolean;
  showReviewExtraction = false;
  private history: string[] = [];

  /**
   * set event data
   * @param widgetData
   */
  set widgetData(widgetData: any) { }

  /**
   * set event config
   * @param config
   */
  set widgetConfig(config: any) {
    this.config = config.widgetPayload;
    this._formHandlerService.getForm(get(this.config, 'create.formId'));
    this._fileService.setFileUploadOptions(get(this.config, 'upload.fileOptions'));

    if(get(this.config, 'showEventsGroup') === false) {
      this.showEventsGroup = false;
    }
    if(get(this.config, 'showAddButton') === false) {
      this.showAddButton = false;
    }
    if(get(this.config, 'showEventList') === false) {
      this.showEventList = false;
    }

    this.showLaunchPacsInEventContent = get(this.config, 'showLaunchPacsInEventContent', true);
    this.showLaunchPacsInReportPreview = get(this.config, 'showLaunchPacsInReportPreview', false);
    this.showNewAddButton = get(this.config, 'showNewAddButton', false);
    this.isGroupByDate = get(this.config, 'isGroupByDate', false);
    this.isEditable = get(this.config, 'isEditable', true);
    this.maxEventSelection = get(this.config, 'maxEventSelection', 0);
    this.showMiniEventList = get(this.config, 'showMiniEventList', false);
    this.readOnlyMode = get(this.config, 'readOnlyMode', false);
    if (this.widgetFormInstance && !this.readOnlyMode) {
      this.readOnlyMode = get(this.widgetFormInstance, 'disabled', false);
    }
    if (this.readOnlyMode) {
      this.permitPanCancerEventWrite = false;
    }

    if(get(this.config, 'permitOnlyAssignee') && !this.readOnlyMode) {
      this._workflowUtilService.checkIfPerformer().pipe(takeUntil(this.asyncdestroyer.asObservable())).subscribe(isPerformer => {
        this.permitPanCancerEventWrite = this.permitPanCancerEventWrite && isPerformer;
      });
    }
  }

  constructor(private activatedRoute: ActivatedRoute,
              private _eventService: EventService,
              private changeDetector: ChangeDetectorRef,
              private notificationMessageService: NotificationMessageService,
              private notificationMessage: NOTIFICATION_MESSAGE,
              private _ngZone: NgZone,
              private el: ElementRef,
              private _formHandlerService: FormHandlerService,
              private _modalLoaderService: ModalLoaderNgjsService,
              private _fileService: FileService,
              private _store: Store<IgenomicsState>,
              private authService: AuthenticationService,
              private aggregatorService: AgregationService,
              private _contextProviderService: ContextProviderService,
              private _workflowUtilService: WorkflowUtilService,
              private _translate: TranslateService,
              private _eventWizardService: EventValidationWizardService,
              private _pacsLauncherService: PacsLauncherService,
              private _orderService: OrderService,
              private routerManagerService: RouterManagerService) {
    this.permitPanCancerEventRead = this.authService.doesUserHasPermission(PermissionSchemaConstants.getPermissionSchema('panCancerEventRead'));
    this.permitPanCancerEventWrite = this.authService.doesUserHasPermission(PermissionSchemaConstants.getPermissionSchema('panCancerEventWrite'));
  }

  ngOnInit() {
    if (!this.permitPanCancerEventRead) {
      this._modalLoaderService.popupModal('confirm',
        ConfirmModalLoaderPayload.builder()
          .setTitle('Access Denied')
          .setContent('You don`t currently have permission to access events. Please contact administrator.')
          .setApproveButtonText('Close'),
        'ERROR'
      ).subscribe((response: modalResponse) => {
        window.history.back();
      });
      return;
    }

    this.load = false;
    this._pacsLauncherService.init().then(() => {
      //Required when directly events are reloaded .
      this.aggregatorService.updateCurrentInstanceData({'organization':this.authService.user.organization})
      this._contextProviderService.clearContexts(['events', 'category']);
      if (get(this.config, 'dataComposer')) {
        this._contextProviderService.fetchDataFromDataBindings(get(this.config, 'dataComposer')).then(data => {
          this.filterCategory = this._contextProviderService.getContextBindingByKey('category')
          this.filterCategory = get(this.filterCategory, '[0].data.category');
          this.initEventPreparation(true);
        });
      } else {
        this.initEventPreparation();
      }
      this._eventService.getViewWizard().pipe(takeUntil(this.asyncdestroyer.asObservable()),distinctUntilChanged()).subscribe(resp => this.showReviewExtraction = resp);
    });
  }

  /**
   * Change selected event
   * @param event
   */
  changeSelectedEvent(event: IEvent) {
    if(!this.eventDataUpdated) {
      this._eventService.currentTabTitle = null;
      this.setSelectedEvent(event);
    } else {
      this._modalLoaderService.popupModal('confirm',
        ConfirmModalLoaderPayload.builder()
          .setTitle(this._translate.instant('DISCARD_DATA') || 'Discard Data')
          .setContent(this._translate.instant('UN_SAVED_CHANGES') || 'Unsaved changes have been made to current event. Would you like to continue (changes will not be saved)?.')
          .setDeclineButtonText('Cancel')
          .setApproveButtonText(this._translate.instant('CONTINUE') || 'Continue'),
        'ALERT').subscribe(response => {
        if (get(response, 'payload') === modalResponse.approve) {
          this._eventService.currentTabTitle = null;
          this.eventDataUpdated = false;
          this.setSelectedEvent(event);
        }
      });
    }
  }

  setSelectedEvent(event: IEvent){
    this._eventService.setSelectedEvent(event);
    this.pacsIntegrationAvailable = this._pacsLauncherService.getPacsVisibilityStatus(event);
    this.changeDetector.markForCheck();
  }

  /**
   * Toggle right panel
   * @param showPanel
   */
  changeTogglePanel(showPanel: boolean) {
    this._ngZone.runOutsideAngular(() => {
      this.listEl = this.listEl ? this.listEl : this.el.nativeElement.querySelector('ispm-pan-cancer-events-list');
      this.contentEl = this.contentEl ? this.contentEl : this.el.nativeElement.querySelector('ispm-event-content-viewer');
      setTimeout(() => {
        this.showEventsPanel = showPanel;
        if (this.showEventsPanel) {
          this.listEl.style.width = '20%';
          if (this.contentEl) {
            this.contentEl.style.width = 'calc(80% - 0.5em)';
          }
        } else {
          this.listEl.style.width = '4em';
          if (this.contentEl) {
            this.contentEl.style.width = 'calc(100% - 5em)';
          }
        }
      }, 10);
    });
  }

  /**
   * Show create event popup
   */
  showCreateEventPopup() {
    this._eventService.currentTabTitle = null;
    this._formHandlerService.popupDynamicFormModal(
      this._translate.instant('ADD_NEW_EVENT') || 'Add new event',
      get(this.config, 'create.formId'),
      { },
      this._translate.instant('patientList_AddButtonLabel') || 'Add',
      'Cancel',
      { },
      EventService.ModalLoaderTunnelName,
      null,
      false).take(1).subscribe(
      data => {
        if (get(data, 'status') === modalResponse.approve) {
          this._store.dispatch({
            type: CORE_ACTIONS.SET_LOADER,
            payload: true
          });
          this._eventService.formsPrefecth([get(data,'payload.formData.category.code')]);
          this.createEvent(get(data, 'payload.formData'));
        }
      }
    );
  }

  /**
   * format event data and create event in resource
   * @param formData
   */
  async createEvent(formData: any) {
    const currentUser = (await this._eventService.authService).user;
    const fileData = get(formData, 'file.file');
    formData = omit(formData, 'file');
    const event = <IEvent> formData;
    set(event, 'content', []);
    if (fileData) {
      const fileInfo = { contentType: 'file', resourceType: 'FileResource'};
      set(fileInfo, 'reference', get(fileData, 'referenceId'));
      set(fileInfo, 'name', get(fileData, 'name'));
      set(event, 'content', [fileInfo]);
    }
    // set(event, 'approved', true);
    const context = [];
    context.push({ reference: this.patientId, 'resourceType': 'Patient'});
    context.push({ reference: currentUser.id, 'resourceType': 'Practitioner'});
    set(event, 'context', context);

    //format date
    let tempDate = new Date(get(event, 'date'));
    tempDate.setHours(new Date().getHours());
    tempDate.setMinutes(new Date().getMinutes());
    tempDate.setSeconds(new Date().getSeconds());
    set(event, 'date', tempDate.toISOString().split('+')[0]);

    this._eventService.createEvent(event).subscribe(latestEvent => {
        this.setSelectedEvent(latestEvent);
        this.notificationMessageService.success(this.notificationMessage.EVENT_CREATED_SUCCESSFULLY);
        this._eventService.getAllEventsAndStore(get(this.config, 'queryParams', null));
        this._store.dispatch({
          type: CORE_ACTIONS.SET_LOADER,
          payload: false
        });
      },
      error => {
        this.notificationMessageService.error(this.notificationMessage.FAILED_TO_CREATE_EVENT);
        this._store.dispatch({
          type: CORE_ACTIONS.SET_LOADER,
          payload: false
        });
      });
  }

  /**
   * Delete event instead archiving
   * @param event
   */
  deleteEvent(event: IEvent) {
    this._modalLoaderService.popupModal('confirm',
      ConfirmModalLoaderPayload.builder()
        .setTitle(this._translate.instant('DELETE_EVENT') || 'Delete Event')
        .setContent(this._translate.instant('DELETE_TEXT') || 'Are you sure you want to delete event?')
        .setApproveButtonText('Confirm')
        .setDeclineButtonText('Cancel'),
      'ALERT'
    ).subscribe((response: modalResponse) => {
      if (get(response, 'payload') === modalResponse.approve) {
        this._eventService.currentTabTitle = null;
        set(event, 'archived', true);
        this._eventService.updateEvent(event.id, event, true).subscribe(data => {
            if (event.id === this.selectedEvent.id) {
              this.selectedEvent = this.events[0];
              this.setSelectedEvent(this.selectedEvent);
            }
            this._eventService.getAllEventsAndStore(get(this.config, 'queryParams', null));
          this.notificationMessageService.success(this.notificationMessage.EVENT_DELETED_SUCCESSFULLY);
          },
          error => {
            this.notificationMessageService.error(this.notificationMessage.FAILED_TO_DELETE_EVENT);
          });
      }
    });
  }

  private initEventPreparation(hasExtraContext?: boolean) {
    this._eventService.getAllEventsAndStore(get(this.config, 'queryParams', null));
    this.patientId = this.routerManagerService.parameters.patientId;
    this.eventDataSubscription = combineLatest(
      this._eventService.getAllEventDefinition(),
      this._eventService.getAllEvents(),
      this._workflowUtilService.getCurrentAndPreviousWorkflow(get(this.config, 'filters.considerWorkflow')))
      .subscribe(data => {
      this.eventsDefinitions = data[0];
      this.eventCatAndEvents = new Map<string, Array<IEvent>>();
      this.events = data[1].valueSeq().toArray();
      let eventContexts = this._contextProviderService.getFormattedContext('events');
      if (hasExtraContext && eventContexts && eventContexts.length > 0 && isEmpty(get(this.config, 'filters.basedOnDate'))) {
        this.events = this.events.filter(event => {
          if (event['context']) {
            return this._eventService.checkEventHasContext(event);
          } else {
            return false;
          }
        });
      }
      if(get(this.config, 'filters') && !isEmpty(get(this.config, 'filters.basedOnDate'))) {
        const basedOnDate = get(this.config, 'filters.basedOnDate');
        let filterDateDuration = this.getFileterDateDuration(basedOnDate, data);
        let workflowSpecificEvents = [];
        if(!isEmpty(this.events)) {
          workflowSpecificEvents = this.events.filter(event => {
            if (this.checkWorkflowContext(event, get(data, ['2', 'currentWorkflow', 'id']))) {
              return event;
            }
          });
        }
        if(isEmpty(workflowSpecificEvents)) {
          set(filterDateDuration, 'eventOrWorkflowMinDate', Date.parse(get(data[2], 'currentWorkflow.meta.created')));
        } else {
          if (workflowSpecificEvents.length > 1) {
           workflowSpecificEvents.sort((a, b) => Date.parse(get(a, 'meta.created')) - Date.parse(get(b, 'meta.created')));
          }
          const olderDate = Date.parse(get(workflowSpecificEvents,['0','date'])) < Date.parse(get(data ,['2','currentWorkflow','meta','created'])) ?
            Date.parse(get(workflowSpecificEvents,['0','date'])) : Date.parse(get(data ,['2','currentWorkflow','meta','created']));
          set(filterDateDuration, 'eventOrWorkflowMinDate', olderDate);
        }
        this.events = this._eventService.getAllEventsBasedOnDate(this.events, this.filterCategory, data[2], filterDateDuration);
      }
      if (this.events.length > 0 && this.eventsDefinitions.size > 0) {
        this.events = filter(this.events, event => {
          if(!get(event, 'archived')) {
            if (get(this.config, 'onlySelected')) {
              return get(event, 'selected');
            }
            return true;
          }
          return false;
        });
        this.events = sortBy(this.events, (event => {
          return moment(event.date).format('YYYYMMDDTHH:mm:ss');
        })).reverse();
        if (this.isGroupByDate) {
          this.events.forEach((e) => {
            if (!get(e, 'archived')) {
              const eventYear = moment(e.date).format("YYYY");
              const group = { code: eventYear, display: eventYear, 'iconName': 'icon__Calendar' };
              set(e, 'group', group);
              set(e, 'event_icon',  'icon__Calendar');
              this.eventCatAndEvents.get(group.display) ? this.eventCatAndEvents.get(group.display).push(e) :
                this.eventCatAndEvents.set(group.display, [e]);
            }
          });
        } else {
          this.events.forEach((e) => {
            if (!get(e, 'archived')) {
              let eventDefn = this.eventsDefinitions.get(e.category.code);
              let group = get(eventDefn, 'ui.group');
              group = group ? group : {code: 'others', display: 'Other Events', 'iconName': 'icon__DocumentText'};
              set(e, 'group', group);
              set(e, 'event_icon',  get(eventDefn, 'ui.timeline.markerIcon') ? get(eventDefn, 'ui.timeline.markerIcon') : 'icon__DocumentText');
              this.eventCatAndEvents.get(group.display) ? this.eventCatAndEvents.get(group.display).push(e) :
                this.eventCatAndEvents.set(group.display, [e]);
            }
          });
        }
        this.changeDetector.markForCheck();
        this.eventSelectedSubscription = this._eventService.getSelectedEvent().pipe(takeUntil(this.asyncdestroyer.asObservable())).subscribe(dats => {
            if (get(dats, 'category') && !get(dats, 'group')) {
              let group = get(this.eventsDefinitions.get(dats.category.code), 'ui.group');
              group = group ? group : {code: 'others', display: 'Other Events', 'iconName': 'icon__DocumentText'};
              set(dats, 'group', group);
            }
            if(dats) {
              let eventIndex = findIndex(this.events, event => {
                return get(event, 'id') === get(dats, 'id');
              })
              if(eventIndex > -1) {
                this.selectedEvent = dats;
              }
            }
            if(has(this.selectedEvent, "isExternal")){
              this.isExternal = get(this.selectedEvent, "isExternal");
            }else{
              this.isExternal = false;
            }

            if (!(this.selectedEvent) && !isEmpty(this.events)) {
              this.selectedEvent = this.events[0];
              this.setSelectedEvent(this.selectedEvent);
            }
            else{
              this.pacsIntegrationAvailable = this._pacsLauncherService.getPacsVisibilityStatus(this.selectedEvent);
            }
            this.changeDetector.markForCheck();
            this.load = true;
        });
      }
    });
  }

  checkWorkflowContext(event, workflowReference): boolean {
    return event['context'].find(context => {
      return context.reference === workflowReference ? true : false;
    });
  }

  getFileterDateDuration(basedOnDate, data) {
    let workflowCreatedDate = false;
    let duration = [];
    for (let key of Object.keys(basedOnDate)) {
      if (key === get(data ,['2','currentWorkflow','name']) && basedOnDate[key] === 'WORKFLOW_CREATED_DATE') {
        return {'workflowCreatedDate': true,'duration': duration };
      } else if (key === get(data ,['2','currentWorkflow','name']) && basedOnDate[key].includes('last')){
        return {'workflowCreatedDate': false,'duration': basedOnDate[key].split("_") };
      }
    }
    return {'workflowCreatedDate': workflowCreatedDate,'duration': duration };
  }

  selectEvent(eventSelection) {
   this.eventSelection = Object.assign({}, eventSelection);
  }

  changeDataEvent(isDataUpdated) {
    this.eventDataUpdated = isDataUpdated;
  }

  backToDashBoard(){
    this.routerManagerService.back();
  };

/*  getViewWizard(){
    returthis.store$.select('viewWizard').subscribe(resp => {

    })
  }*/

  /**
   * On destory
   */
  ngOnDestroy(): void {
    if(this.eventDataSubscription){
      this.eventDataSubscription.unsubscribe();
    }
    if(this.eventSelectedSubscription){
      this.eventSelectedSubscription.unsubscribe();
    }
    if(get(this.config, 'forceClear')) {
      this.events = null;
      this._eventService.clearEvents();
    }
    if(!isEmpty(get(this.config, 'orderInformationPopup'))) {
      this._orderService.resetStore();
    }
    this.selectedEvent = null;
  this._eventService.setSelectedEvent(null);
    this.asyncdestroyer.next();
    this.asyncdestroyer.complete();
  }

  closeReviewExtraction() {
    this._eventService.clearViewWizard();
  }
}
